import React, { useState, useEffect } from "react";
import {
  Box,
  Drawer,
  AppBar,
  CssBaseline,
  Toolbar,
  List,
  IconButton,
  Typography,
  Divider,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  CircularProgress,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import HomeIcon from "@mui/icons-material/Home";
import GroupIcon from "@mui/icons-material/Group";
import LinkIcon from "@mui/icons-material/Link";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import SettingsIcon from "@mui/icons-material/Settings";
import { useMediaQuery, useTheme } from "@mui/material";
import { Link } from "react-router-dom";
import { getCurrentUser } from "../api/api"; // API Call to SQL Server

const drawerWidth = 240;

const Header = ({ children }) => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [loadingAdmin, setLoadingAdmin] = useState(true);
  const [mobileOpen, setMobileOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  useEffect(() => {
    const checkUserRole = async () => {
      setLoadingAdmin(true);
      try {
        const user = await getCurrentUser();
        if (user) {
          setIsAdmin(user.role === "admin");
        }
      } catch (error) {
        console.error("Error checking admin status:", error);
      } finally {
        setLoadingAdmin(false);
      }
    };

    checkUserRole();
  }, []);

  const toggleDrawer = () => {
    setMobileOpen(!mobileOpen);
  };

  const navItems = [
    { text: "Home", icon: <HomeIcon />, path: "/" },
    { text: "Teams", icon: <GroupIcon />, path: "/teams" },
    { text: "Link", icon: <LinkIcon />, path: "/link" },
    { divider: true },
    { text: "Settings", icon: <SettingsIcon />, path: "/settings" },
  ];

  if (isAdmin) {
    navItems.push({ text: "Admin", icon: <AdminPanelSettingsIcon />, path: "/admin" });
  }

  const drawerContent = (
    <Box sx={{ width: drawerWidth }}>
      {/* Logo at the top */}
      <Box sx={{ textAlign: "center", mt: 2, mb: 2 }}>
        <img
          style={{
            width: "90%",
            maxWidth: "150px",
            paddingTop: "5px",
            paddingBottom: "5px",
            margin: "5px 16px",
          }}
          src="/images/logo/Logoname.png"
          alt="Logo"
        />
      </Box>

      <Divider />

      {loadingAdmin ? (
        <Box sx={{ textAlign: "center", mt: 2 }}>
          <CircularProgress size={24} />
        </Box>
      ) : (
        <List>
          {navItems.map((item, index) =>
            item.divider ? (
              <Divider key={`divider-${index}`} sx={{ my: 1 }} />
            ) : (
              <ListItem key={index} disablePadding>
                <ListItemButton component={Link} to={item.path} onClick={toggleDrawer}>
                  <ListItemIcon>{item.icon}</ListItemIcon>
                  <ListItemText primary={item.text} />
                </ListItemButton>
              </ListItem>
            )
          )}
        </List>
      )}
    </Box>
  );

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />

      {/* Top Navigation Bar */}
      <AppBar position="fixed" sx={{ background: "#fff" }}>
        <Toolbar>
          {isMobile && (
            <IconButton color="inherit" edge="start" onClick={toggleDrawer}>
              <MenuIcon />
            </IconButton>
          )}
          {/* Logo in Navbar */}
          <img
            style={{
              width: "90%",
              maxWidth: "90px",
              //maxHeight: "40px",
              paddingTop: "5px",
              paddingBottom: "5px",
              margin: "5px 16px",
            }}
            src="/images/logo/Logoname.png"
            alt="Logo"
          />
        </Toolbar>
      </AppBar>

      {/* Sidebar Drawer for Desktop */}
      {!isMobile && (
        <Drawer
          variant="permanent"
          sx={{
            width: drawerWidth,
            flexShrink: 0,
            [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: "border-box" },
          }}
        >
          {drawerContent}
        </Drawer>
      )}

      {/* Drawer (Collapsible Sidebar) for Mobile */}
      {isMobile && (
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={toggleDrawer}
          sx={{
            [`& .MuiDrawer-paper`]: { width: drawerWidth },
          }}
        >
          {drawerContent}
        </Drawer>
      )}

      {/* Main Content */}
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <Toolbar />
        {children}
      </Box>
    </Box>
  );
};

export default Header;
